import styled from 'styled-components';
import React, { FC } from 'react';
import { CommonComponentProps, FieldValidationState } from '@clds/common-definitions';
import { globalTheme } from '@clds/component-theme';
import { typographyMixin, TypographyProps } from '@clds/typography';
import { CheckCircle, Error, Warning } from '@clds/icon';
import { asStyledComponent } from '@cld/component-enhancer';
import { formTheme, validationVariant } from './theme';

export interface ValidationProps extends CommonComponentProps<'p'> {
  /** Type of validation message */
  type?: FieldValidationState;
  className?: string;
}

const Root = styled.p<{ type: FieldValidationState }>`
  display: flex;
  align-items: flex-start;
  margin: ${formTheme.validation.margin.vertical} 0;
  ${validationVariant((branch) => typographyMixin(branch as TypographyProps))};

  svg {
    margin-right: ${globalTheme.spacing.xxs};
    height: ${globalTheme.spacing.sm};
    width: ${globalTheme.spacing.sm};
    flex-shrink: 0;
  }
`;

const getIcon = (validationState: FieldValidationState) =>
  ({
    none: null,
    success: <CheckCircle size="sm" />,
    warning: <Error size="sm" />,
    error: <Warning size="sm" />,
  }[validationState]);

export const ValidationMessage = asStyledComponent<FC<ValidationProps>>(({ type = 'none', rootProps, children, className }) => (
  <Root data-test="validation-info" type={type} {...rootProps} className={className}>
    {getIcon(type)}
    <span>{children}</span>
  </Root>
));
